// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__MIMlb","upload":"Small_upload__1nC1g","imageWrap":"Small_imageWrap__2nJYF","removeBtn":"Small_removeBtn__1w8tJ"};